<nz-modal
  #modalRef
  nzSize
  [(nzVisible)]="isVisible"
  [nzTitle]="(isEdit ? 'Edit' : 'Add') + ' Health Care File Plan' | translate"
  (nzOnCancel)="handleCancel()"
  nzCancelText="Cancel"
  nzOkText="Save"
  nzOkType="primary"
  [nzFooter]="null"
  class="custom-modal-class"
>
  <ng-container *nzModalContent>
    <form
      [formGroup]="carePlanFileForm"
      (ngSubmit)="submitForm()"
      [ngClass]="{
        'carePlanFile-submitted': carePlanFileSubmitted,
        'carePlanFile-not-submitted': !carePlanFileSubmitted
      }"
    >
      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>{{ "Date" | translate }}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
          <input
            nz-input
            class="inputs carePlanFile"
            type="date"
            [placeholder]="'Date...' | translate"
            formControlName="dateValue"
            [max]="this?.carePlanFileForm?.value?.dateValue || getCurrentDate()"
          />
        </div>
      </div>

      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>{{ "File" | translate }}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
          <!-- <nz-upload class="inputs carePlanfile" style="margin-left:1em" [(nzFileList)]="fileList"
            [nzBeforeUpload]="beforeUpload" [nzMultiple]="false" [nzLimit]="1" nzAccept=".pdf">
            <button nz-button type="button">
              <i nz-icon nzType="icons:upload"></i>
              Select File
            </button>
          </nz-upload> -->

          <input
            #fileInput
            accept=".pdf,.png,.jpg"
            class="carePlanFile upload"
            [ngClass]="{
              'ng-invalid': !this.carePlanFileForm.value?.fileValue
            }"
            style="margin-left: 1em"
            type="file"
            (change)="onFileSelected($event)"
          />
        </div>
      </div>

      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>{{ "Description" | translate }}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
          <input
            nz-input
            class="inputs carePlanFile"
            type="text"
            [placeholder]="'Description...' | translate"
            formControlName="descriptionValue"
          />
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="end" class="footer">
        <button
          nz-button
          nzPrimary
          class="save-btn"
          type="submit"
          [nzLoading]="isLoading"
          [disabled]="isLoading"
        >
          {{ "Save" | translate }}
        </button>
        <button
          nz-button
          nzDanger
          class="cancel-btn"
          type="button"
          (click)="handleCancel()"
          [disabled]="isLoading"
        >
          {{ "Cancel" | translate }}
        </button>
      </div>
    </form>
  </ng-container>
</nz-modal>
